import { render } from "./CourseFaqsScreen.vue?vue&type=template&id=ee3d2922&scoped=true"
import script from "./CourseFaqsScreen.vue?vue&type=script&lang=js"
export * from "./CourseFaqsScreen.vue?vue&type=script&lang=js"

import "./CourseFaqsScreen.vue?vue&type=style&index=0&id=ee3d2922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee3d2922"]])

export default __exports__